import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Link } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

const bannerContainerCss = css({
    backgroundColor: wacToken("color.primary.blue"),
    display: "flex",
    justifyContent: "center",
    textAlign: "left",
    padding: "16px",
    [media.above.sm]: {
        textAlign: "center"
    }
});

const bodyCss = css({
    "color": "#ffffff",
    "fontSize": "16px",
    "margin": "0",
    "maxWidth": "768px",
    "width": "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".link-wrapper": {
        display: "inline"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".link-modifier": {
        textDecoration: "underline"
    }
});

export const Banner = () => {
    const ctaHref =
        "https://community.atlassian.com/t5/Nonprofit-articles/New-nonprofit-discounts-for-Loom-and-Rovo/ba-p/2877008";

    return (
        <div css={bannerContainerCss}>
            <div css={bodyCss}>
                <FormattedMessage
                    id="NonprofitPage.banner.body"
                    defaultMessage="Loom and Rovo are now available at 75% off for eligible nonprofits. "
                />
                <span>
                    <Link
                        text="Learn more."
                        className="link-modifier"
                        href={ctaHref}
                        anchorProps={{
                            "data-testid": "banner-cta-link"
                        }}
                        bgColor={"bgBlackBlue"}
                    />
                </span>
            </div>
        </div>
    );
};
